"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RequestError = void 0;

var _core = _interopRequireDefault(require("./core"));

var _simpleCustomErrors = _interopRequireDefault(require("simple-custom-errors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RequestError = _simpleCustomErrors["default"].createError('RequestError', [{
  code: 'ApiError',
  description: 'API - {{message}}',
  params: ['code', 'error', 'message', 'transport', 'response']
}]);

exports.RequestError = RequestError;

var Request = /*#__PURE__*/function () {
  function Request() {
    _classCallCheck(this, Request);
  }

  _createClass(Request, null, [{
    key: "defaultHeaders",
    value: function defaultHeaders() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var headers = {}; // Add authentication

      if (options.skipAuth !== true) {
        headers['authorization'] = "Bearer ".concat(_core["default"].auth.accesstoken);
      }

      return headers;
    } // Public functions

  }, {
    key: "beforeRequest",
    value: function () {
      var _beforeRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var hook,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                hook = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;

                if (!(!hook || typeof hook !== 'function')) {
                  _context.next = 3;
                  break;
                }

                throw new Error('beforeRequest hook is not a function');

              case 3:
                this.beforeRequestHooks.push(hook);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function beforeRequest() {
        return _beforeRequest.apply(this, arguments);
      }

      return beforeRequest;
    }() // Private functions

  }, {
    key: "__beforeRequest",
    value: function () {
      var _beforeRequest2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(method, url) {
        var data,
            options,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                options = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};

                if (!(this.beforeRequestHooks.length === 0)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return Promise.all(this.beforeRequestHooks.filter(function (hook) {
                  return typeof hook === 'function';
                }).map(function (hook) {
                  return hook(method, url, data, options);
                }));

              case 6:
                return _context2.abrupt("return", _context2.sent);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function __beforeRequest(_x, _x2) {
        return _beforeRequest2.apply(this, arguments);
      }

      return __beforeRequest;
    }()
  }]);

  return Request;
}();

exports["default"] = Request;
Request.beforeRequestHooks = [];
Request.RequestError = RequestError;